import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UploadImageState } from '@members/models';
import { Store } from '@ngrx/store';
import { WebcamImage, WebcamInitError } from 'ngx-webcam';
import { Observable, Subject } from 'rxjs';
import { takeWhile } from 'rxjs/operators';
import { StringDto } from 'src/app/models/basic/string-dto';
import { uploadImage } from 'src/app/views/main/views/members/reducers/upload-images/uploadImages.actions';

@Component({
    selector: 'app-webcam',
    templateUrl: './webcam.component.html'
})
export class WebcamComponent implements OnInit {

    @Input() currentUrlImg = '';

    selectedImage!: WebcamImage;

    // toggle webcam on/off
    showWebcam = false;

    // latest snapshot
    webcamImage!: WebcamImage;
    allowCameraSwitch = true;
    multipleWebcamsAvailable = false;
    deviceId!: string;
    errors: WebcamInitError[] = [];

    // webcam snapshot trigger
    private trigger: Subject<void> = new Subject<void>();
    // switch to next / previous / specific webcam; true/false: forward/backwards, string: deviceId
    private nextWebcam: Subject<boolean | string> = new Subject<
    boolean | string
    >();

    uploadImage$: Observable<UploadImageState>;
    urlImage = '';
    isAlive = true;

    @Output() updateUrlImg: EventEmitter<string> = new EventEmitter();

    constructor(private store: Store<{uploadImage: UploadImageState}>) {
        this.uploadImage$ = this.store.select(data => data.uploadImage);
    }

    ngOnInit(): void {
        this.uploadImage$.pipe(takeWhile(() => this.isAlive)).subscribe(image => {
            if (image?.uri?.length) {
                this.showWebcam = false;
                this.urlImage = image.uri;
                this.updateUrlImg.emit(this.urlImage);
            }
        });
    }

    takeSnapshot(): void {
        this.trigger.next();
    }

    // ON OFF Camera
    toggleWebcam(): void {
        this.showWebcam = !this.showWebcam;
    }

    // Switch to next camera device if avaiable
    showNextWebcam(directionOrDeviceId: boolean | string): void {
        this.nextWebcam.next(directionOrDeviceId);
    }

    handleInitError(error: WebcamInitError): void {
        this.errors.push(error);
    }

    takePicture(webcamImage: WebcamImage): void {
        this.webcamImage = webcamImage;
        const imgUpload: StringDto = {
            value: this.webcamImage.imageAsBase64
        };
        this.store.dispatch(uploadImage({base64: imgUpload}));
    }

    cameraWasSwitched(deviceId: string): void {
        this.deviceId = deviceId;
    }

    get initObservable(): Observable<void> {
        return this.trigger.asObservable();
    }

    get nextWebcamObservable(): Observable<boolean | string> {
        return this.nextWebcam.asObservable();
    }
}
